// extracted by mini-css-extract-plugin
module.exports = {"c-seo-text-title":"_025a50318d--c-seo-text-title--qtKHs","c-seo-text-col":"_025a50318d--c-seo-text-col--z4HtV"};